import { render, staticRenderFns } from "./EditCallback.vue?vue&type=template&id=112cd528"
import script from "./EditCallback.vue?vue&type=script&lang=js"
export * from "./EditCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports